import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/ravir2.jpeg";
import Tilt from "react-parallax-tilt";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refresh();


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 data-aos="fade-up"
              data-aos-duration="1000"
              style={{ fontSize: "2.2em" }}>
              About Me
            </h1>
            <p data-aos="fade-right" data-aos-duration="1000" className="home-about-body">
              <span>I'm Ravi Ranjan Ram and I'm a Developer</span>
              <br />
              A full stack web developer having knowledge in Data Structure, Algorithms, and Programming languages. Knowing JavaScript, HTML, CSS, React, Redux, Mern Stack, MongoDB and Chakra UI, I have made some solo and collaborative projects and continue to have some experience as well as acquiring more knowledge. Now I'm looking forward to enhance my skills in a challenging work environment.
            </p>
          </Col>
          <Col data-aos="fade-left" data-aos-duration="1000" md={4} className="myAvtar">
            <Tilt className="img_myAvtar">
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

      </Container>
    </Container>
  );
}
export default Home2;
